import { setReactInputValue, selectFirstReactSelectOption, openMenuAndGet } from '../../shared/domHelpers'
import { demoRoutes, setDemoTourResume } from '../DemoFlow'
import demoStore from '../mock/DemoStore'
import { skipStageConfig, DEMO_MONITORADO_LISTA_INTRO_INDEX } from '../demoSkipStage'
import { withNativeDemoSaveAllowed } from '../demoSaveControls'
import { disablePopoverButtons } from '../../tourUi'
const delay = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds))
const SUCCESS_MODAL_READING_TIME = 500
const LISTA_READY = '[data-tour="cliente-novo"], [data-tour="cliente-lista"], [data-tour="help-cliente-grid"]'
const FORM_READY = '[data-tour="cliente-form-root"], input[name="nome_fantasia"], [data-tour="cliente-salvar"]'
const MONITORADO_LISTA_READY = '[data-tour="monitorado-novo"], [data-tour="monitorado-lista"], [data-tour="help-monitorado-grid"]'

const getMenuListaClientes = () => openMenuAndGet('cliente', 'group-cliente', '[data-tour="menu-lista-clientes"]')

const fillNomeFantasia = () => {
    const nomeFantasiaInput =
        document.querySelector('[data-tour="cliente-nome-fantasia"] input') ||
        document.querySelector('input[name="nome_fantasia"]')
    if (nomeFantasiaInput) setReactInputValue(nomeFantasiaInput, 'Cliente Demonstração')
}

const fillPerfilStatus = async () => {
    const statusAtivo = document.querySelector('[data-tour="cliente-status"] input[value="ativo"]')
    if (statusAtivo && !statusAtivo.checked) statusAtivo.click()
    await selectFirstReactSelectOption('[data-tour="cliente-perfil"]')
}

const fillOpcionais = () => {
    const opcionais = document.querySelector('[data-tour="cliente-opcionais"]')
    if (opcionais && !opcionais.open) opcionais.open = true

    const razaoSocialInput =
        document.querySelector('[data-tour="cliente-razao-social"] input') ||
        document.querySelector('input[name="razao_social"]')
    const emailAdminInput =
        document.querySelector('[data-tour="cliente-email-admin"] input') ||
        document.querySelector('input[name="email_administrador"]')
    const pessoaFisica = document.querySelector('[data-tour="cliente-pessoa-tipo"] input[value="fisica"]')

    if (razaoSocialInput) setReactInputValue(razaoSocialInput, 'Cliente Demonstração LTDA')
    if (emailAdminInput) setReactInputValue(emailAdminInput, 'demo@afira.io')
    if (pessoaFisica && !pessoaFisica.checked) pessoaFisica.click()
}

const waitSuccessModal = (tourManager, timeout = 8000) =>
    tourManager.waitForElement(() => {
        const body = document.querySelector('.modal.show .modal-body, .modal.show .modal-content')
        if (body && /sucesso|criado|editado/i.test(body.textContent || '')) return body
        return null
    }, timeout)

const closeSuccessModalSoft = () => {
    const buttons = Array.from(document.querySelectorAll('.modal.show .modal-footer button, .modal.show button'))
    const fechar = buttons.find((button) => /^fechar$/i.test((button.textContent || '').trim()))
    if (fechar) {
        fechar.click()
        return
    }
    document.querySelector('.modal.show .close')?.click()
}

const ensureClienteInStore = () => {
    if (!demoStore.state.cliente) {
        demoStore.createCliente({ nome_fantasia: 'Cliente Demonstração' })
    }
}

const goToMonitorado = async (tourManager) => {
    ensureClienteInStore()

    setDemoTourResume('demo-monitorado', demoRoutes.monitoradoLista, DEMO_MONITORADO_LISTA_INTRO_INDEX)

    if (tourManager.isActive()) {
        tourManager.finish('demo-cliente')
    }

    const startMonitorado = () => {
        tourManager.start('demo-monitorado', { resumeIndex: DEMO_MONITORADO_LISTA_INTRO_INDEX })
    }

    if (tourManager.history) {
        tourManager.history.replace(demoRoutes.monitoradoLista)
        try {
            await tourManager.waitForElement(MONITORADO_LISTA_READY, 8000)
        } catch (error) {}
        await delay(200)
        startMonitorado()
        return
    }

    window.location.href = demoRoutes.monitoradoLista
}

const prepareAndSaveCliente = async (tourManager) => {
    if (tourManager._hdvSavingCliente) return
    tourManager._hdvSavingCliente = true
    disablePopoverButtons({ next: true, prev: true })

    try {
        fillNomeFantasia()
        await fillPerfilStatus()
        fillOpcionais()
        await delay(100)

        const saveButton = document.querySelector('[data-tour="cliente-salvar"]')
        if (saveButton) {
            withNativeDemoSaveAllowed(saveButton, () => saveButton.click())
        }

        try {
            await waitSuccessModal(tourManager)
            await delay(SUCCESS_MODAL_READING_TIME)
        } catch (error) {}

        ensureClienteInStore()
        setDemoTourResume('demo-monitorado', demoRoutes.monitoradoLista, DEMO_MONITORADO_LISTA_INTRO_INDEX)

        if (document.querySelector('.modal.show')) {
            closeSuccessModalSoft()
            await delay(150)
        }

        await goToMonitorado(tourManager)
    } catch (error) {
        ensureClienteInStore()
        await goToMonitorado(tourManager)
    } finally {
        setTimeout(() => {
            tourManager._hdvSavingCliente = false
        }, 800)
    }
}

const buildDemoClienteTourSteps = (tourManager) => [
    {
        element: getMenuListaClientes,
        ensureReady: () => {
            if (!demoStore.state.perfil) {
                demoStore.createPerfil({ nome: 'Perfil Demonstração' })
            }
            const menuItem = getMenuListaClientes()
            if (menuItem) return Promise.resolve(menuItem)
            return tourManager.waitForElement(getMenuListaClientes)
        },
        popover: {
            title: 'Lista de Clientes',
            description: 'No menu, este item abre a lista de clientes. Vamos cadastrar um cliente fictício vinculado ao perfil da demonstração.',
            side: 'right',
            align: 'start',
            onNextClick: () => {
                tourManager.navigateAndWait(demoRoutes.clienteLista, LISTA_READY, 1, 'demo-cliente')
                    .then(() => tourManager.moveNext())
                    .catch(() => tourManager.moveNext())
            },
        },
    },
    {
        element: '[data-tour="cliente-novo"]',
        ensureReady: () => tourManager.waitForElement(LISTA_READY),
        skipStage: skipStageConfig('monitoradoLista'),
        popover: {
            title: 'Demonstração: Cliente',
            description: 'Aqui ficam os clientes cadastrados. Clique em <strong>Próximo</strong> para abrir o formulário de novo cliente.<br><br>Clique em <strong>Pular etapa</strong> para finalizar imediatamente esse cadastro e ir para o próximo.',
            side: 'bottom',
            align: 'start',
            onNextClick: () => {
                tourManager.navigateAndWait(demoRoutes.clienteNovo, FORM_READY, 2, 'demo-cliente')
                    .then(() => tourManager.moveNext())
                    .catch(() => tourManager.moveNext())
            },
        },
    },
    {
        element: '[data-tour="cliente-nome-fantasia"]',
        ensureReady: () =>
            tourManager.waitForElement('[data-tour="cliente-nome-fantasia"] input, input[name="nome_fantasia"]'),
        popover: {
            title: 'Nome fantasia',
            description: 'Nome de exibição do cliente na plataforma.',
            side: 'bottom',
            align: 'start',
            onNextClick: async () => {
                fillNomeFantasia()
                await delay(150)
                tourManager.moveNext()
            },
        },
    },
    {
        element: '[data-tour="cliente-perfil"]',
        popover: {
            title: 'Perfil e status',
            description: 'Associamos o perfil criado e deixamos o cliente ativo.',
            side: 'bottom',
            align: 'start',
            onNextClick: async () => {
                await fillPerfilStatus()
                await delay(150)
                tourManager.moveNext()
            },
        },
    },
    {
        element: '[data-tour="cliente-opcionais"]',
        popover: {
            title: 'Dados opcionais',
            description: 'E-mail administrador, razão social e tipo de pessoa devem ser preenchidos para completar o formulário.',
            side: 'top',
            align: 'start',
            onNextClick: async () => {
                fillOpcionais()
                await delay(150)
                tourManager.moveNext()
            },
        },
    },
    {
        element: '[data-tour="cliente-salvar"]',
        popover: {
            title: 'Salvar cliente',
            description: 'Clique em <strong>Próximo</strong>, o guia salva o cliente e segue automaticamente para o Monitorado.',
            side: 'top',
            align: 'end',
            nextBtnText: 'Salvar e continuar',
            onNextClick: () => prepareAndSaveCliente(tourManager),
        },
    },
    {
        popover: {
            title: 'Cliente salvo',
            description: 'Abrindo o cadastro de Monitorado…',
            side: 'over',
            align: 'center',
            showButtons: ['close'],
        },
    },
]

export default buildDemoClienteTourSteps
